import { SearchSpringResults } from "./../types";
import {
  QuickReplyButton,
  DataField,
  KnowledgeBaseSearchResults,
  CalendlyResult,
  BotState,
  Form
} from "../types";
import { EventEmitter } from "events";

class BotStore {
  private _emitter = new EventEmitter();

  //settings
  private _enableTextReplies: boolean;
  private _enableAudio: boolean;
  private _enableTypingIndicator: boolean;
  private _enableTimestamps: boolean;
  private _messageSpeed: number;

  //state
  private _status: string;
  private _quickReplies: QuickReplyButton[];
  private _dataField: DataField;
  private _form: Form;
  private _knowledgeBaseSearchResults: KnowledgeBaseSearchResults;
  private _searchSpringResults: SearchSpringResults;
  private _calendlyResult: CalendlyResult;

  setSettings(botState: BotState) {
    if (!botState) {
      return;
    }

    this._enableTextReplies = botState.EnableTextReplies;
    this._enableAudio = botState.EnableAudio;
    this._enableTypingIndicator = botState.EnableTypingIndicator;
    this._enableTimestamps = botState.EnableTimestamps;
    this._messageSpeed = botState.MessageSpeed;
  }
  setState(botState: BotState) {
    if (!botState) {
      return;
    }

    this._status = botState.Status;
    this._quickReplies = botState.QuickReplies;
    this._knowledgeBaseSearchResults = botState.KnowledgeBaseSearchResults;
    this._searchSpringResults = botState.SearchSpringResults;
    this._calendlyResult = botState.CalendlyResult;
    this._dataField = botState.DataField;
    this._form = botState.Form;
  }

  emitState() {
    this._emitter.emit("setQuickReplies", this._quickReplies);
    this._emitter.emit("setDataField", this._dataField);
    this._emitter.emit("setForm", this._form);
  }

  clearState() {
    this.clearEnableTextReplies();
    this.clearStatus();
    this.clearQuickReplies();
    this.clearDataField();
    this.clearForm();
    this.clearKnowledgeBaseSearchResults();
    this.clearCalendlyResult();
    this.clearSearchSpringResults();
  }

  textRepliesEnabled() {
    return this._enableTextReplies;
  }

  clearEnableTextReplies() {
    this._enableTextReplies = null;
  }

  getStatus() {
    return this._status;
  }

  clearStatus() {
    this._status = null;
  }

  getQuickReplies() {
    return this._quickReplies;
  }

  clearQuickReplies() {
    this._quickReplies = null;
    this._emitter.emit("setQuickReplies", null);
  }

  getDataField() {
    return this._dataField;
  }

  clearDataField() {
    this._dataField = null;
    this._emitter.emit("setDataField", null);
  }

  getForm() {
    return this._form;
  }

  clearForm() {
    this._form = null;
    this._emitter.emit("setForm", null);
  }

  getKnowledgeBaseSearchResults() {
    return this._knowledgeBaseSearchResults;
  }

  clearKnowledgeBaseSearchResults() {
    this._knowledgeBaseSearchResults = null;
  }

  getSearchSpringResults() {
    return this._searchSpringResults;
  }

  clearSearchSpringResults() {
    this._searchSpringResults = null;
  }

  getCalendlyResult() {
    return this._calendlyResult;
  }

  clearCalendlyResult() {
    this._calendlyResult = null;
  }

  onSetDataField(callback: (dataField: DataField) => void) {
    this._emitter.addListener("setDataField", callback);
  }

  onSetForm(callback: (form: Form) => void) {
    this._emitter.addListener("setForm", callback);
  }

  onSetQuickReplies(callback: (quickReplies: QuickReplyButton[]) => void) {
    this._emitter.addListener("setQuickReplies", callback);
  }

  botAudioEnabled() {
    return this._enableAudio;
  }

  botTypingIndicatorEnabled() {
    return this._enableTypingIndicator;
  }

  botTimestampsEnabled() {
    return this._enableTimestamps;
  }

  getMessageSpeed() {
    return this._messageSpeed;
  }
}

export default BotStore;
